// This dictionary contains 14 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { surveyLocalization } from "survey-core";

export var greekSurveyStrings = {
  pagePrevText: "Προηγούμενο",
  pageNextText: "Επόμενο",
  completeText: "Ολοκλήρωση",
  previewText: "Προεπισκόπηση",
  editText: "Επεξεργασία",
  startSurveyText: "Αρχή",
  otherItemText: "Άλλο (παρακαλώ διευκρινίστε)",
  noneItemText: "Κανένας",
  selectAllItemText: "Επιλογή όλων",
  progressText: "Σελίδα {0} από {1}",
  // indexText: "{0} of {1}",
  panelDynamicProgressText: "Εγγραφή {0} από {1}",
  questionsProgressText: "Απαντήθηκαν {0} / {1} ερωτήσεις",
  emptySurvey: "Δεν υπάρχει καμία ορατή σελίδα ή ορατή ερώτηση σε αυτό το ερωτηματολόγιο.",
  completingSurvey: "Ευχαριστούμε για την συμπλήρωση αυτού του ερωτηματολογίου!",
  completingSurveyBefore: "Τα αρχεία μας δείχνουν ότι έχετε ήδη ολοκληρώσει αυτήν την έρευνα.",
  loadingSurvey: "Το ερωτηματολόγιο φορτώνεται απο το διακομιστή...",
  placeholder: "Επιλέξτε...",
  // ratingOptionsCaption: "Tap to rate here...",
  value: "αξία",
  requiredError: "Παρακαλώ απαντήστε στην ερώτηση.",
  requiredErrorInPanel: "Απαντήστε σε τουλάχιστον μία ερώτηση.",
  requiredInAllRowsError: "Παρακαλώ απαντήστε στις ερωτήσεις σε όλες τις γραμμές.",
  numericError: "Η τιμή πρέπει να είναι αριθμητική.",
  // minError: "The value should not be less than {0}",
  // maxError: "The value should not be greater than {0}",
  textMinLength: "Παρακαλώ συμπληρώστε τουλάχιστον {0} σύμβολα.",
  textMaxLength: "Εισαγάγετε λιγότερους από {0} χαρακτήρες.",
  textMinMaxLength: "Εισαγάγετε περισσότερους από {0} και λιγότερους από {1} χαρακτήρες.",
  minRowCountError: "Παρακαλώ συμπληρώστε τουλάχιστον {0} γραμμές.",
  minSelectError: "Παρακαλώ επιλέξτε τουλάχιστον {0} παραλλαγές.",
  maxSelectError: "Παρακαλώ επιλέξτε όχι παραπάνω απο {0} παραλλαγές.",
  numericMinMax: "Το '{0}' θα πρέπει να είναι ίσο ή μεγαλύτερο απο το {1} και ίσο ή μικρότερο απο το {2}",
  numericMin: "Το '{0}' πρέπει να είναι μεγαλύτερο ή ισο με το {1}",
  numericMax: "Το '{0}' πρέπει να είναι μικρότερο ή ίσο απο το {1}",
  invalidEmail: "Παρακαλώ δώστε μια αποδεκτή διεύθυνση e-mail.",
  invalidExpression: "Η έκφραση: {0} θα πρέπει να επιστρέψει 'true'.",
  urlRequestError: "Η αίτηση επέστρεψε σφάλμα '{0}'. {1}",
  urlGetChoicesError: "Η αίτηση επέστρεψε κενά δεδομένα ή η ιδιότητα 'μονοπάτι/path' είναι εσφαλμένη",
  exceedMaxSize: "Το μέγεθος δεν μπορεί να υπερβαίνει τα {0}.",
  otherRequiredError: "Παρακαλώ συμπληρώστε την τιμή για το πεδίο 'άλλο'.",
  uploadingFile: "Το αρχείο σας ανεβαίνει. Παρακαλώ περιμένετε καποια δευτερόλεπτα και δοκιμάστε ξανά.",
  loadingFile: "Φόρτωση...",
  chooseFile: "Επιλογή αρχείων ...",
  noFileChosen: "Δεν έχει επιλεγεί αρχείο",
  // fileDragAreaPlaceholder: "Drop a file here or click the button below to load the file.",
  confirmDelete: "Θέλετε να διαγράψετε την εγγραφή;",
  keyDuplicationError: "Αυτή η τιμή πρέπει να είναι μοναδική.",
  addColumn: "Προσθήκη στήλης",
  addRow: "Προσθήκη γραμμής",
  removeRow: "Αφαίρεση",
  // emptyRowsText: "There are no rows.",
  addPanel: "Προσθεσε νεο",
  removePanel: "Αφαιρώ",
  choices_Item: "είδος",
  matrix_column: "Στήλη",
  matrix_row: "Σειρά",
  // multipletext_itemname: "text",
  savingData: "Τα αποτελέσματα αποθηκεύονται στον διακομιστή ...",
  savingDataError: "Παρουσιάστηκε σφάλμα και δεν ήταν δυνατή η αποθήκευση των αποτελεσμάτων.",
  savingDataSuccess: "Τα αποτελέσματα αποθηκεύτηκαν με επιτυχία!",
  saveAgainButton: "Προσπάθησε ξανά",
  timerMin: "ελάχ",
  timerSec: "δευτ",
  timerSpentAll: "Έχετε δαπανήσει {0} σε αυτήν τη σελίδα και {1} συνολικά.",
  timerSpentPage: "Έχετε ξοδέψει {0} σε αυτήν τη σελίδα.",
  timerSpentSurvey: "Έχετε ξοδέψει συνολικά {0}.",
  timerLimitAll: "Έχετε δαπανήσει {0} από {1} σε αυτήν τη σελίδα και {2} από {3} συνολικά.",
  timerLimitPage: "Έχετε ξοδέψει {0} από {1} σε αυτήν τη σελίδα.",
  timerLimitSurvey: "Έχετε ξοδέψει {0} από {1} συνολικά.",
  clearCaption: "Σαφή",
  // signaturePlaceHolder: "Sign here",
  chooseFileCaption: "Επιλέξτε το αρχείο",
  removeFileCaption: "Καταργήστε αυτό το αρχείο",
  booleanCheckedLabel: "Ναί",
  booleanUncheckedLabel: "Οχι",
  confirmRemoveFile: "Είστε βέβαιοι ότι θέλετε να καταργήσετε αυτό το αρχείο: {0};",
  confirmRemoveAllFiles: "Είστε βέβαιοι ότι θέλετε να καταργήσετε όλα τα αρχεία;",
  questionTitlePatternText: "Τίτλος ερώτησης",
  // modalCancelButtonText: "Cancel",
  // modalApplyButtonText: "Apply",
  // filterStringPlaceholder: "Type to search...",
  // emptyMessage: "No data to display",
  // noEntriesText: "There are no entries yet.\nClick the button below to add a new entry.",
  // more: "More"
};

surveyLocalization.locales["gr"] = greekSurveyStrings;
surveyLocalization.localeNames["gr"] = "ελληνικά";
